import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Buffer } from 'buffer';
import { isEmpty } from 'ramda';
import { toAnalyticsKeysWithOverrides } from './formatters';

var toEncodedHeader = function toEncodedHeader(obj) {
  return Buffer.from(JSON.stringify(obj)).toString('base64');
};

export var toClientDetailsHeader = function toClientDetailsHeader(clientDetails) {
  // Support legacy code until callisto migrates
  if (!clientDetails) {
    return {};
  }

  return isEmpty(clientDetails) ? {} : {
    headers: {
      'Peloton-Client-Details': toEncodedClientDetails(clientDetails)
    }
  };
};
export var toEncodedClientDetails = function toEncodedClientDetails(clientDetails) {
  if (!clientDetails) {
    return '';
  }

  var details = isLegacySource(clientDetails) ? {
    Source: clientDetails
  } : fromAnyPropsToStringProps(clientDetails);
  return toEncodedHeader(toAnalyticsKeysWithOverrides(details));
};
/* The following two functions are used in Members where we don't want
to stringify the client details to maintain lists in analytics headers.*/

export var toClientDetailsHeaderWithoutStringify = function toClientDetailsHeaderWithoutStringify(clientDetails) {
  // Support legacy code until callisto migrates
  if (!clientDetails) {
    return {};
  }

  return isEmpty(clientDetails) ? {} : {
    headers: {
      'Peloton-Client-Details': toEncodedClientDetailsWithoutStringify(clientDetails)
    }
  };
};
export var toEncodedClientDetailsWithoutStringify = function toEncodedClientDetailsWithoutStringify(clientDetails) {
  if (!clientDetails) {
    return '';
  }

  var details = isLegacySource(clientDetails) ? {
    Source: clientDetails
  } : clientDetails;
  return toEncodedHeader(toAnalyticsKeysWithOverrides(details));
};
export var toClientDetails = function toClientDetails(screenProps, source) {
  return _objectSpread(_objectSpread({}, screenProps), {}, {
    Source: source
  });
};

var isLegacySource = function isLegacySource(details) {
  return typeof details === 'string';
};

export var fromAnyPropsToStringProps = function fromAnyPropsToStringProps(props) {
  Object.keys(props).forEach(function (key) {
    if (typeof props[key] !== 'string') {
      // TODO: is this a TS bug?
      props[key] = String(props[key]);
    }
  });
  return props;
};